var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"二维码","visible":_vm.visible,"width":"300px"},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.close}},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("\n    请扫码查看溯源信息\n  ")]),_c('canvas',{ref:"canvas",staticClass:"qrcode"})])
}
var staticRenderFns = []

export { render, staticRenderFns }